import { useTranslation } from "react-i18next";
import { DocumentText1, Calendar } from "iconsax-react";
import { EmptyState } from "@/shared/components";
import { FileViewer } from "@/shared/ui";
import type { ScientificWorkRecord } from "../../types/personalSheet";
import ProfileDataRow from "../ProfileDataRow";

interface Props {
  records: ScientificWorkRecord[];
  hasNoScientificWorks?: boolean;
}

export default function ScientificWorksSection({ records, hasNoScientificWorks }: Props) {
  const { t } = useTranslation("EmployeePortal");

  if (records.length === 0) {
    if (hasNoScientificWorks) {
      return <p className="text-body-regular-md content-base-secondary">{t("personalSheet.noScientificWorksDeclared")}</p>;
    }
    return <EmptyState noDataText={t("personalSheet.empty.scientificWorks")} noDataHint={t("personalSheet.empty.scientificWorksHint")} compact />;
  }

  return (
    <div className="flex flex-col gap-6">
      {records.map(function renderRecord(record, index) {
        return (
          <div key={record.id} className="flex flex-col gap-4">
            <div className="flex flex-col">
              <p className="text-label-md content-base-primary mb-3">
                {t("personalSheet.recordNumber", { number: index + 1 })}
              </p>
              <ProfileDataRow
                icon={DocumentText1}
                label={t("personalSheet.fields.scientificWorkTitle")}
                value={record.title}
              />
              <ProfileDataRow
                icon={Calendar}
                label={t("personalSheet.fields.scientificWorkYear")}
                value={record.year || null}
              />
            </div>
            {record.file_url && (
              <div className="flex flex-col gap-1.5">
                <span className="text-label-sm content-base-secondary">{t("personalSheet.fields.scientificWorkFile")}</span>
                <FileViewer existingFileUrl={record.file_url} isDownloadable />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
